import { Hammer } from 'lucide-react';

const Home: React.FC = () => {
    return(
        <div className="flex flex-col justify-center items-center gap-4 h-[calc(100vh-6rem)]">
            <div>
                <Hammer size={100} className='text-custom-blue3'/>
                {/* <img src="./Illustration2.jpg" width={300}/> */}
            </div>
            <div className="bg-white rounded-lg flex flex-row items-center justify-center gap-4">
                <h1 className="text-5xl font-medium text-custom-blue7 pl-2">Work in progress!</h1>
            </div>
        </div>
    )
}
export default Home;